function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#wowicon .cls-1{fill:#fcd226;}#wowicon .cls-2{fill:#fdeb4e;}#wowicon .cls-3{fill:#f7b722;}#wowicon .cls-4{fill:#88271f;}#wowicon .cls-5{fill:#e85a50;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,14S.49,8.21,3.55,5.28,9.56.4,15.76,0,25.83,5.91,26.43,7s2.38,4.44,2.38,7,0,8-3.65,10.38-7.2,3.8-9.74,3.67-8.93-.67-11.8-4.67S0,18.14,0,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M14.91,3a5.14,5.14,0,0,1,3.91.45.18.18,0,0,0,.25-.24c-.55-1-2-2.83-4.32-.51A.17.17,0,0,0,14.91,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M9.14,25.43c-1.5-1.55-3.5-3.5-3.3-10.2S7.64,6.16,8.79,4.38A15.15,15.15,0,0,1,14.24.15,16.51,16.51,0,0,0,3.55,5.28C.49,8.21,0,14,0,14c0,4.09.75,5.37,3.62,9.38s9.27,4.53,11.8,4.66C15.42,28.08,10.64,27,9.14,25.43Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Left_eye",
  "data-name": "Left eye",
  className: "cls-3",
  cx: 9.89,
  cy: 9.71,
  rx: 1.7,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Left_eye-2",
  "data-name": "Left eye",
  className: "cls-3",
  cx: 20.96,
  cy: 9.71,
  rx: 1.7,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 16.01,
  cy: 19.54,
  rx: 4.1,
  ry: 4.74
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M12.79,21.57a3.64,3.64,0,0,0,3.95,2.22,2.13,2.13,0,0,0-1.13-2.72A2.28,2.28,0,0,0,12.79,21.57Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Left_eye-3",
  "data-name": "Left eye",
  className: "cls-4",
  d: "M8.51,9.23a2,2,0,0,1,1.7-2.18,2,2,0,0,1,1.7,2.18,2,2,0,0,1-1.7,2.19A2,2,0,0,1,8.51,9.23Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Left_eye-4",
  "data-name": "Left eye",
  className: "cls-4",
  d: "M19.58,9.23a2,2,0,0,1,1.7-2.18A2,2,0,0,1,23,9.23a2,2,0,0,1-1.7,2.19A2,2,0,0,1,19.58,9.23Z"
})));

var SvgWow = function SvgWow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wowicon",
    viewBox: "0 0 28.81 28.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wow.80e54c8d.svg";
export { ForwardRef as ReactComponent };